// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"484":"77f0df29","551":"b07edcaf"}[chunkId] + ".chunk.js";
};